var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckDouble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#000;stroke-linecap:round;stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.206 2.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.636,6l-8,8L4,10.364",
    transform: "translate(-3.887 -0.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.974,6l-8,8L5,12.026",
    transform: "translate(2.5 -0.7)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckDouble);
export default __webpack_public_path__ + "static/media/Icon_Check_Double.59cb375e388bf830df1979ef990ffb85.svg";
export { ForwardRef as ReactComponent };